import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _createClass from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldInitSpec from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import _classPrivateFieldGet from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/es.weak-map.get-or-insert.js";
import "core-js/modules/es.weak-map.get-or-insert-computed.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _observeBody = /*#__PURE__*/new WeakMap();
var _getImage = /*#__PURE__*/new WeakMap();
var _draw = /*#__PURE__*/new WeakMap();
var _createHDCanvas = /*#__PURE__*/new WeakMap();
var _observeWatermarkDom = /*#__PURE__*/new WeakMap();
export var Watermark = /*#__PURE__*/_createClass(
// 观察者对象，监听body相关配置变化
function Watermark() {
  var _this = this;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck(this, Watermark);
  _classPrivateFieldInitSpec(this, _observeBody, null);
  // 生成水印节点
  _defineProperty(this, "create", function () {
    if (_this.hasWatermark) return; // 防止重复创建水印
    try {
      var _classPrivateFieldGet2, _classPrivateFieldGet3;
      var targetNode = document.getElementsByClassName(_this.targetNode)[0] || document.body;
      _this.watermark = document.createElement("div");
      _this.watermark.className = "watermark";
      _this.watermark.style.cssText = "\n        z-index: ".concat(_this.zIndex, " !important;\n        position: fixed !important;\n        pointer-events: none !important;\n        height: ").concat(targetNode.scrollHeight, "px !important;\n        min-height: 100%;\n        width: 100% !important;\n        top: 0px !important;\n        left: 0px !important;\n        background-image: url(").concat(_classPrivateFieldGet(_getImage, _this).call(_this), ") !important;\n        background-size: ").concat(_this.width, "px ").concat(_this.height, "px !important;\n        background-repeat: repeat !important;\n        background-position: ").concat(_this.backgroundPosition, " !important;\n      ");
      targetNode.appendChild(_this.watermark);
      _this.hasWatermark = true; // 防止重复创建水印
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_observeBody, _this)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : (_classPrivateFieldGet3 = _classPrivateFieldGet2.disconnect) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.call(_classPrivateFieldGet2); // 暂停对目标节点的观察，直到重新调用observe方法
      _classPrivateFieldGet(_observeWatermarkDom, _this).call(_this); // 对目标节点的相关变动进行监听
    } catch (_unused) {
      _this.errCallback();
    }
  });
  // 移除水印节点
  _defineProperty(this, "remove", function () {
    var _classPrivateFieldGet4, _classPrivateFieldGet5, _this$watermark;
    (_classPrivateFieldGet4 = _classPrivateFieldGet(_observeBody, _this)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : (_classPrivateFieldGet5 = _classPrivateFieldGet4.disconnect) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.call(_classPrivateFieldGet4);
    (_this$watermark = _this.watermark) === null || _this$watermark === void 0 ? void 0 : _this$watermark.parentNode.removeChild(_this.watermark);
    _this.watermark = null;
    _this.hasWatermark = false;
  });
  // 将canvas转换成image
  _classPrivateFieldInitSpec(this, _getImage, function () {
    var image;
    try {
      var canvas = _classPrivateFieldGet(_draw, _this).call(_this);
      image = canvas.toDataURL("image/png", 1);
      canvas.remove();
    } catch (_unused2) {
      _this.errCallback();
    }
    return image;
  });
  // canvas画水印内容
  _classPrivateFieldInitSpec(this, _draw, function () {
    // 1.创建canvas元素
    var canvas = _classPrivateFieldGet(_createHDCanvas, _this).call(_this);
    // 2.获取上下文
    var context = canvas.getContext("2d");
    // 字体
    context.font = _this.font;
    // 对齐方式
    context.textAlign = "center";
    // 底部对齐方式(top  bottom middle)
    context.textBaseline = "middle";
    // 字体颜色
    context.fillStyle = _this.color;
    // 设置透明度
    context.globalAlpha = _this.globalAlpha;
    // 平移转换,修改原点
    context.translate(_this.width / 2, _this.height / 2);
    // 旋转画布
    context.rotate(_this.rotate);
    // 绘制填充文本(文字左下角的X坐标,文字左下角的Y坐标);
    var contentType = Object.prototype.toString.call(_this.content);
    var temp = ["[object Array]", "[object Object]"]; // 数组或对象
    // 如果content是数组或对象时，当做多行处理
    if (temp.includes(contentType)) {
      var posY = 0;
      for (var key in _this.content) {
        context.fillText(_this.content[key], 0, posY);
        posY += _this.fontSize + 4;
      }
    } else {
      context.fillText(_this.content, 0, 0);
    }
    return canvas;
  });
  // 创建高清Canvas
  _classPrivateFieldInitSpec(this, _createHDCanvas, function () {
    var ratio = window.devicePixelRatio || 1;
    var canvas = document.createElement("canvas");
    canvas.width = _this.width * ratio; // 实际渲染像素
    canvas.height = _this.height * ratio; // 实际渲染像素
    canvas.style.width = "".concat(_this.width, "px"); // 控制显示大小
    canvas.style.height = "".concat(_this.height, "px"); // 控制显示大小
    canvas.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
    return canvas;
  });
  // 监听body里面水印节点的变化，重新渲染
  _classPrivateFieldInitSpec(this, _observeWatermarkDom, function () {
    // 选择要监听的节点
    var targetNode = document.querySelector("body");
    // 选择要监听节点的哪些变化
    var config = {
      childList: true,
      // 监听子节点的增删
      attributes: true,
      // 监听自身属性的变化
      subtree: true // 监听所有后代节点的变化(增删、属性变化、内容变化)
    };
    // 当监听到目标节点相关变化时执行的回调函数
    var callback = function callback(mutationsList) {
      // console.log('mutationsList', mutationsList);
      var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.target === _this.watermark) {
            var _item$removedNodes, _item$removedNodes$, _item$target;
            item === null || item === void 0 ? void 0 : (_item$removedNodes = item.removedNodes) === null || _item$removedNodes === void 0 ? void 0 : (_item$removedNodes$ = _item$removedNodes[0]) === null || _item$removedNodes$ === void 0 ? void 0 : _item$removedNodes$.remove();
            item === null || item === void 0 ? void 0 : (_item$target = item.target) === null || _item$target === void 0 ? void 0 : _item$target.remove();
            _this.watermark = null;
            _this.hasWatermark = false; // 防止重复创建水印
            _this.create();
            return;
          }
          if (item.removedNodes[0] === _this.watermark) {
            _this.watermark = null;
            _this.hasWatermark = false; // 防止重复创建水印
            _this.create();
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    // 创建一个观察者对象
    var mutationObserver = MutationObserver;
    var observer = new mutationObserver(callback);
    // 注册需要观察的目标节点
    observer.observe(targetNode, config);
    _classPrivateFieldSet(_observeBody, _this, observer);
  });
  // 水印消失或者创建失败后的默认回调
  _defineProperty(this, "defaultErrCallback", function () {
    window.alert("水印被未知操作篡改，请刷新页面重新加载水印");
  });
  if (this.hasWatermark) return; // 防止重复创建水印
  this.targetNode = props.targetNode; // 要添加水印的目标节点,如果不存在则添加全局水印
  this.content = props.content || ""; // 水印文本
  this.fontWeight = props.fontWeight || "normal"; // 字体的粗细
  this.fontSize = props.fontSize || 16; // 字体大小 px
  this.fontFamily = props.fontFamily || "sans-serif"; // font-family
  this.font = "".concat(this.fontWeight, " ").concat(this.fontSize, "px ").concat(this.fontFamily);
  this.color = props.color || "#666666"; // 水印文本颜色
  this.globalAlpha = props.alpha || 0.15; // 水印文本透明度 0~1 0 表示完全透明，1 表示完全不透明
  this.width = props.width || 300; // 单个水印宽度 px
  this.height = props.height || 170; // 单个水印高度 px
  this.zIndex = props.zIndex || 2147483647; // 水印节点层级(默认为最大层级)
  this.backgroundPosition = props.backgroundPosition || "0px 0px, 0px 0px"; // 水印节点的背景图片位置
  this.rotate = (props.rotate || 330) * Math.PI / 180; // 水印旋转角度，以左上角为原点旋转，注意旋转角度影响水印文本显示
  this.watermark = null; // 水印节点
  this.errCallback = props.errCallback || this.defaultErrCallback; // 水印创建失败的处理函数
});